import React from 'react';
import { CATEGORIES, catColor, categorizeEvent } from '../../config/categories';
import { isEventCanceled } from '../../utils/eventUtils';
import { fs } from '../../utils/typography';

// Month-cell event chip — "bar" treatment: no background of its own, just a
// 3px rounded category-color bar + truncated title + uppercase mono org line.
const EventChip = ({ event, tokens, onClick }) => {
    const c = tokens.colors;
    const cat = categorizeEvent(event);
    const cc = catColor(cat, tokens);
    const canceled = isEventCanceled(event);
    return (
        <div
            style={{ display: 'flex', gap: 7, alignItems: 'stretch', padding: '2px 0', cursor: 'pointer', opacity: canceled ? 0.55 : 1 }}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }}
            aria-label={`View details for ${event.title} by ${event.organization}${canceled ? ' (canceled)' : ''}`}
            title={`${event.title} — ${event.organization}${canceled ? ' (Canceled)' : ''}`}
        >
            <div style={{ width: 3, borderRadius: 2, background: cc.strong, flex: '0 0 auto' }} />
            <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{
                    fontFamily: tokens.fonts.ui, fontSize: fs(14), fontWeight: 600, color: c.ink, lineHeight: 1.25,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    textDecoration: canceled ? 'line-through' : 'none',
                }}>
                    <i className={`fas ${CATEGORIES[cat].icon}`} style={{ color: cc.strong, fontSize: fs(9.5), marginRight: 3 }} aria-hidden="true" />
                    {canceled && (
                        <i className="fas fa-ban" style={{ color: c.faint, fontSize: fs(11), marginRight: 4 }} aria-label="Canceled event" />
                    )}
                    {!canceled && event.eventType === 'Featured' && (
                        <i className="fas fa-star" style={{ color: cc.strong, fontSize: fs(11), marginRight: 4 }} aria-label="Featured event" />
                    )}
                    {event.title}
                </div>
                <div style={{
                    fontFamily: tokens.fonts.mono, fontSize: fs(11), fontWeight: 500, letterSpacing: 0.2, color: c.faint,
                    textTransform: 'uppercase', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 1,
                }}>{event.organization}</div>
            </div>
        </div>
    );
};

export default EventChip;
